//
//
//
//
//
//

export default {
    name: "Parallax",

    props: {

        // Whether to only activate the parallax for tiny screens
        xSmall: {
            type: Boolean,
            default: false
        },

        // Whether to only activate the parallax for small screens
        small: {
            type: Boolean,
            default: false
        },

        // Whether to only activate the parallax for medium screens
        medium: {
            type: Boolean,
            default: false
        },

        // Whether to only activate the parallax for large screens
        large: {
            type: Boolean,
            default: false
        },

        // Whether to only activate the parallax for extra large screens
        xLarge: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            topPosition: null
        }
    },

    computed: {
        style() {
            return this.topPosition !== null ? {
                willChange: 'transform',
                transform: `translate3d(0px, ${this.topPosition}px, 0px)`
            } : null
        },

        shouldAdaptTopPosition() {
            return (!this.xSmall && !this.small && !this.medium && !this.large && !this.xLarge) || (this.xSmall && this.$breakpoint.xsOnly) || (this.small && this.$breakpoint.smOnly) || (this.medium && this.$breakpoint.mdOnly) || (this.large && this.$breakpoint.lgOnly) || (this.xLarge && this.$breakpoint.xlOnly);
        }
    },

    created() {
        this.handleScroll();
    },

    methods: {
        handleScroll() {
            if (this.shouldAdaptTopPosition) {
                const scrollPosition = typeof window !== 'undefined' ? window.scrollY : 0;
                this.topPosition = (scrollPosition / 1.8)
            } else {
                this.topPosition = null;
            }
        }
    }
}
